import styled from 'styled-components';
import theme from 'styles/theme';

export const TextMedium = styled.p`
  width: 100%;
  padding: 30px 0 16px;
  font-size: 18px;
  font-weight: 500;
  line-height: 34px;
  color: ${theme.color.black};
`;

export const Contents = styled.div`
  width: 100%;
  padding-bottom: 30px;
  line-height: 2.2rem;
  font-size: 1.3rem;
  color: ${props => (props.color ? props.color : '#111')};
  white-space: pre-line;

  .keyGuideTitle {
    display: block;
    margin-bottom: 5px;
    font-weight: 600;
  }
`;

export const ColorSpanRed = styled.span`
  color: ${theme.color.red};
`;

export const ColorSpan = styled.span`
  color: ${props =>
    props.required === false
      ? `${theme.color.policyGrey}`
      : `${theme.color.blue}`};
`;

export const DisagreeNoticeBox = styled.p`
  font-size: 1.3rem;
  line-height: 2.1rem;
  color: #666;
  margin-bottom: 44px;
`;

export const TextLight = styled.div`
  width: 100%;
  padding: 12px 0 18px;
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 2.1rem;
  text-align: center;
  color: ${theme.color.black};
`;

export const TextLeftAlign = styled(TextLight)`
  text-align: left;
  font-size: 1.3rem;
  font-weight: 500;
  line-height: 2.4rem;
  word-break: keep-all;

  em {
    color: #666;
    font-weight: normal;
  }
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background: ${theme.backgroundColor.lightGrey};
  margin: ${props => (props.margin ? props.margin : '20px 0 23px')};
`;

export const TextButton = styled.button`
  display: block;
  margin: 28px auto 0;

  text-align: center;
  font-size: 1.3rem;
  font-weight: 500;
  text-decoration: underline;
`;

export const NoticeTitle = styled.p`
  font-weight: 600;
  margin-bottom: 5px;
`;
export const List = styled.ul`
  line-height: 2.5rem;
`;

export const Text = styled.li``;

export const InfoToolTip = styled.p`
  padding: 0 0 5px;
  font-size: 1.3rem;
  font-weight: 500;
  svg {
    vertical-align: text-bottom;
  }
`;

export const DeepLinkAgreeWrapper = styled.div`
  padding: 0 20px 60px;
`;
